/*
 * fn: scrollToTarget
 *
 * Scroll the page to the target set by the page link
 *
 */
import { type ScrollType } from '@/defs/scroll'

import { scrollToAnchor } from './scrollToAnchor'
import { scrollToTop } from './scrollToTop'

type Props = {
  hash?: string
  scroll?: ScrollType
}

export const scrollToTarget = ({ hash, scroll }: Props) => {
  if (scroll === false) return

  if (typeof scroll === 'object') {
    scrollToAnchor(scroll)
    return
  }

  if (!scroll && hash) {
    scrollToAnchor({ id: hash })
    return
  }

  scrollToTop()
}
